// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ss-5";
export var filledCircle = "_ss-4";
export var historyEntry = "_ss-3";
export var messageSideLeft = "_ss-1";
export var messageSideRight = "_ss-2";
export var orderTrackingCarouselWrapper = "_ss-6";
export var orderTrackingInfoContainer = "_ss-0";